import { render, staticRenderFns } from "./smsForm.vue?vue&type=template&id=e845eda2&scoped=true&"
import script from "./smsForm.vue?vue&type=script&lang=babel&"
export * from "./smsForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e845eda2",
  null
  
)

export default component.exports